import { COMMON_CONSTANTS, getTranslatedText } from '@nile/components';
import { checkMDMVisibility } from '../Hooks/useMDMVisibility';
import { FormattedMessage } from 'react-intl';

import React from 'react';

export const settingsModuleObj = (args) => {
  const {
    intl,
    flags,
    isMSP,
    user,
    userDetail,
    appContext,
    currentProduct
  } = args;

  const loadRMMAppProperties =
    appContext?.rmmProperties['rmm.policyManagementType'];

  function useCheckFeatureGating(feature) {
    const allowedFeatures = appContext?.planFeatureList;
    return allowedFeatures?.[feature];
  }
  const showNetworkView = useCheckFeatureGating('network-monitoring-system');

  const agentFeatures =
    appContext?.user?.rmmAppProperties?.betaAgentBasedFeatures;

  const isWindowsManagement = useCheckFeatureGating('WINDOWS_MANAGEMENT');

  const isNewContracts = useCheckFeatureGating('CONTRACT_V3')?.enabled;

  const isMSPProduct = currentProduct === COMMON_CONSTANTS.MSP;

  const mdmFeature = useCheckFeatureGating('MDM');
  const shouldShowMDM = checkMDMVisibility(appContext, mdmFeature, true);

  const settingsMenuList = {
    profileList: {
      name: 'profile',
      title: userDetail ? (
        userDetail.firstName + ' ' + userDetail.lastName
      ) : (
        <FormattedMessage id="admin.stepnavi.myprofile" />
      ),
      data: [
        {
          label: user
            ? `${user.name}`
            : getTranslatedText(intl, 'admin.stepnavi.profileInfo'),
          icon: 'employees',
          url: '/onboard/profile',
          svgIcon: 'Employee'
        },
        {
          label: getTranslatedText(
            intl,
            'admin.stepnavi.twoFactorAuthentication'
          ),
          icon: 'TFA',
          url: '/onboard/profile',
          tabname: 'security',
          svgIcon: 'Tfa',
          onlyInModal: true,
          featureGateName: 'TFA'
        },
        {
          name: 'billingAndInvoice',
          label: getTranslatedText(intl, 'admin.stepnavi.billing&Invoice'),
          url: '/onboard/billing',
          svgIcon: 'BillingAndInvoice'
        }
      ]
    },
    mspSettingsList: {
      name: 'my msp',
      title: <FormattedMessage id="common.my.company" />,
      data: [
        {
          label: getTranslatedText(intl, 'admin.mspDetails.header'),
          url: '/onboard/organisation',
          svgIcon: 'MspInformation',
          name: 'mspInformation'
        },
        {
          label: getTranslatedText(intl, 'common.site'),
          url: '/onboard/site',
          svgIcon: 'Site',
          productToCheck: 'IT',
          name: 'companySite'
        },
        {
          label: getTranslatedText(intl, 'common.department'),
          url: '/onboard/department',
          svgIcon: 'Department',
          productToCheck: 'IT',
          name: 'department'
        },
        {
          name: 'employees',
          label: getTranslatedText(intl, 'common.users'),
          url: '/onboard/employee',
          svgIcon: 'Employee'
        },
        {
          name: 'mailSettings',
          label:
            flags?.supportChannels && !isMSPProduct
              ? getTranslatedText(intl, 'admin.stepnavi.supportChannels')
              : getTranslatedText(intl, 'admin.stepnavi.emailserver'),
          url: '/onboard/mailserver',
          svgIcon: 'MailSettings'
        },

        {
          name: 'holidayList',
          label: getTranslatedText(intl, 'admin.stepnavi.holiday'),
          url: '/onboard/holidaylist',
          show: true,
          svgIcon: 'HolidayList',
          featureGateName: 'TICKETING'
        },
        {
          name: 'onboardingNotificationTemplate',
          label: getTranslatedText(
            intl,
            'settings.stepNav.notificationCenter.title'
          ),
          url: '/onboard/notificationcenter',
          svgIcon: 'OnboardingNotificationTemplate'
        }
      ]
    },
    contractAndBillingList: {
      name: 'contract and billing',
      title: <FormattedMessage id="app.settings.contractAndBilling" />,
      productToCheck: 'MSP',
      data: [
        {
          name: 'serviceCatalog',
          label: getTranslatedText(
            intl,
            isNewContracts
              ? 'admin.product.and.services.title'
              : 'admin.stepnavi.serviceCatalog'
          ),
          url: '/onboard/serviceCatalog',
          svgIcon: 'ServiceCatalog',
          featureGateName: 'SERVICE_CATALOG'
        },
        {
          name: 'tax',
          label: getTranslatedText(intl, 'admin.stepnavi.tax'),
          url: '/onboard/tax',
          svgIcon: 'Tax',
          featureGateName: 'TAX'
        },
        {
          url: '/onboard/timetracking',
          label: getTranslatedText(intl, 'admin.stepnavigation.timeTracking'),
          name: 'serviceCatalog',
          id: 'timeTracking',
          svgIcon: 'Worklog',
          featureGateName: 'TICKETING'
        },
        ...(isNewContracts
          ? [
              {
                url: '/onboard/contractTemplate',
                label: getTranslatedText(
                  intl,
                  'app.modules.workspace.contractTemplate'
                ),
                id: 'contractTemplate',
                svgIcon: 'Contract',
                name: 'contractTemplate',
                permission: 'view'
              }
            ]
          : [])
      ]
    },
    accessControlList: {
      name: 'roles and groups',
      title: <FormattedMessage id="app.settings.access" />,

      data: [
        {
          name: 'role',
          label: getTranslatedText(intl, 'admin.stepnavi.techRole'),
          icon: 'techLogin',
          url: '/onboard/technicianrole',
          svgIcon: 'Employee'
        },
        {
          name: 'role',
          label: getTranslatedText(intl, 'admin.stepnavi.requesterRole'),
          icon: 'requesterLogin',
          url: '/onboard/userrole',
          svgIcon: 'RequesterLogin'
        },
        {
          name: 'technicianGroup',
          label: getTranslatedText(intl, 'admin.stepnavi.techgroup'),
          url: '/onboard/techniciangroup',
          svgIcon: 'TechnicianGroup'
        },
        {
          name: 'requesterGroup',
          label: getTranslatedText(intl, 'admin.stepnavi.requesterGroup'),
          url: '/onboard/requester-groups',
          svgIcon: 'UserGroup',
          productToCheck: COMMON_CONSTANTS.IT,
          flag: 'requesterGroups'
        }
      ]
    },
    ticketSettingList: {
      name: 'ticketing settings',
      title: <FormattedMessage id="app.settings.ticketing" />,
      data: [
        {
          name: 'status',
          label: getTranslatedText(intl, 'common.status'),
          url: '/onboard/ticketstatus',
          svgIcon: 'TicketOutline',
          permissionToCheck: 'customFields.view',

          featureGateName: 'TICKETING'
        },
        {
          name: 'impactUrgencyPriority',
          label: getTranslatedText(intl, 'admin.stepnavi.impUrgPri'),
          url: '/onboard/impacturgencypriority',
          svgIcon: 'ImpactUrgencyPriority',
          permissionToCheck: 'customFields.view',
          featureGateName: 'TICKETING'
        }
      ]
    },
    slaList: {
      name: 'service level agreements',
      title: <FormattedMessage id="app.settings.service" />,

      data: [
        {
          name: 'slaPolicy',
          label: getTranslatedText(intl, 'admin.stepnavi.slapolicy'),
          url: '/onboard/sla',
          svgIcon: 'HourglasswireEnd',
          featureGateName: 'TICKETING'
        },
        {
          name: 'slaMetric',
          label: getTranslatedText(intl, 'admin.stepnavi.slametric'),
          url: '/onboard/slametric',
          svgIcon: 'SlaMetric',
          featureGateName: 'TICKETING'
        }
      ]
    },
    serviceManagment: {
      name: 'service management',
      title: <FormattedMessage id="Service Management" />,
      productToCheck: 'IT',
      data: [
        {
          url: '/onboard/timetracking',
          label: getTranslatedText(intl, 'admin.stepnavigation.timeTracking'),
          name: 'serviceCatalog',
          id: 'timeTracking',
          svgIcon: 'Worklog',
          featureGateName: 'TICKETING'
        },
        {
          name: 'serviceCatalog',
          label: getTranslatedText(intl, 'admin.stepnavi.serviceCatalog'),
          url: '/onboard/serviceCatalog',
          svgIcon: 'ServiceCatalog',
          featureGateName: 'SERVICE_CATALOG'
        }
      ]
    },
    automationRulesList: {
      name: 'automation',
      title: <FormattedMessage id="app.settings.automation" />,
      data: [
        {
          name: 'eventTriggers',
          label: getTranslatedText(intl, 'admin.stepnavi.eventTrigger'),
          url: '/onboard/eventtriggers',
          svgIcon: 'EventTriggers',
          featureGateName: 'TICKETING'
        },
        {
          name: 'timeTriggers',
          label: getTranslatedText(intl, 'admin.stepnavi.timetrigger'),
          url: '/onboard/timetriggers',
          svgIcon: 'TimeTriggers',
          featureGateName: 'TIME_TRIGGERS'
        },
        {
          name: 'ticketScheduler',
          flag: 'ticketScheduler',
          label: getTranslatedText(intl, 'admin.stepnavi.ticketScheduler'),
          url: '/onboard/ticketSchedulers',
          svgIcon: 'TicketScheduler',
          featureGateName: 'TICKETING'
        }
      ]
    },
    assetSettingsList: {
      name: 'asset management',
      title: <FormattedMessage id="app.settings.assetmanagement" />,

      data: [
        {
          name: 'assetCustomFields',
          label: getTranslatedText(intl, 'admin.stepnavi.asset'),
          url: '/onboard/assetclass',
          svgIcon: 'Quantity',
          featureGateName: 'WINDOWS_MANAGEMENT'
        },
        {
          name: 'policySet',
          label: getTranslatedText(intl, 'admin.stepnavi.policy'),
          url: '/onboard/policymgmt-new',
          svgIcon: 'PolicyLight',
          featureGateName: 'POLICY_MANAGEMENT'
        },
        {
          url: '/onboard/it-documentation',
          label: getTranslatedText(intl, 'admin.stepnavi.it.documentation'),
          name: 'itDocumentationCategory',
          icon: 'it-documentation-icon',
          svgIcon: 'ItDocumentationIcon',
          featureGateName: 'IT_DOCUMENTATION'
        },
        {
          url: '/onboard/systemtray',
          label: getTranslatedText(intl, 'admin.agentBranding.header'),
          name: 'systemTrayIcon',
          svgIcon: 'SystemTrayIcon',
          featureGateName: 'WINDOWS_MANAGEMENT'
        }
      ]
    },
    advancedCustomizationList: {
      name: 'advanced configuration',
      title: <FormattedMessage id="app.settings.advanced" />,
      data: [
        {
          label: getTranslatedText(
            intl,
            'admin.stepnavi.identificationNumbers'
          ),
          url: '/onboard/identificationNumbers',
          svgIcon: 'Numbers',
          flag: 'identificationNumbers',
          name: 'identificationNumbers',
          featureGateName: 'ENTITY_ID_GENERATOR'
        },
        {
          label: getTranslatedText(intl, 'admin.stepnavi.templates'),
          url: '/onboard/templates',
          icon: 'tasks',
          svgIcon: 'Tasks',
          featureGateName: 'TEMPLATES',
          authorisation: [
            'ticketTemplate',
            'projectTemplate',
            'replyTemplate',
            'taskTemplate'
          ]
        },
        {
          name: 'runbook',
          label: getTranslatedText(intl, 'admin.stepnavi.runbooks'),
          url: '/onboard/sop',
          svgIcon: 'Runbook',
          featureGateName: 'RUNBOOKS'
        },
        {
          name: 'customerSatisfacationSurvey',
          label: getTranslatedText(intl, 'admin.stepnavi.customer'),
          url: '/onboard/css',
          svgIcon: 'CustomerSatisfacationSurvey',
          featureGateName: 'TICKETING',
          productToCheck: COMMON_CONSTANTS.MSP
        },
        {
          name: 'customerSatisfacationSurvey',
          label: getTranslatedText(intl, 'itsm.satisfaction.survey'),
          url: '/onboard/survey',
          svgIcon: 'CustomerSatisfacationSurvey',
          featureGateName: 'TICKETING',
          productToCheck: COMMON_CONSTANTS.IT
        }
      ]
    },
    generalSettingsList: {
      name: 'security management',
      title: <FormattedMessage id="app.settings.security" />,
      data: [
        {
          name: 'securitySettings',
          label: getTranslatedText(intl, 'admin.stepnavi.techLogin'),
          icon: 'techLogin',
          url: '/onboard/technicianlogin',
          svgIcon: 'Employee',
          productToCheck: COMMON_CONSTANTS.MSP
        },
        {
          name: 'securitySettings',
          label: getTranslatedText(intl, 'admin.stepnavi.requesterLogin'),
          icon: 'requesterLogin',
          url: '/onboard/requesterlogin',
          svgIcon: 'RequesterLogin',
          productToCheck: COMMON_CONSTANTS.MSP
        },
        {
          name: 'securitySettings',
          label: getTranslatedText(intl, 'itsm.user.login'),
          icon: 'techLogin',
          url: '/onboard/technicianlogin',
          svgIcon: 'Employee',
          productToCheck: COMMON_CONSTANTS.IT
        },
        {
          name: 'securitySettings',
          label: getTranslatedText(intl, 'admin.stepnavi.session'),
          icon: 'session',
          url: '/onboard/sessionsettings',
          svgIcon: 'Session'
        },
        {
          name: 'securitySettings',
          label: getTranslatedText(intl, 'admin.stepnavi.IPaddress'),
          icon: 'IPaddress',
          url: '/onboard/ipconf',
          svgIcon: 'IpAddress'
        }
      ]
    },
    othersList: {
      name: 'others',
      title: <FormattedMessage id="app.settings.others" />,
      data: [
        {
          name: 'integrations',
          label: getTranslatedText(intl, 'role.feature.integrations'),
          url: '/onboard/integrations',
          svgIcon: 'Integration'
        },
        {
          name: 'supportAccess',
          label: getTranslatedText(
            intl,
            'admin.stepnavi.customerSupportAccess'
          ),
          url: '/onboard/supportAccess',
          permission: 'allow',
          svgIcon: 'SupportAccess'
        },
        {
          name: 'boucedEmails',
          url: '/onboard/bouncedEmails',
          label: getTranslatedText(intl, 'common.bouncedEmails'),
          svgIcon: 'BouncedEmail',
          permissionToCheck: 'mailSettings.view',
          permission: 'view'
        }
      ]
    }
  };

  if (isMSP) {
    settingsMenuList['profileList'].data.push({
      label: getTranslatedText(intl, 'admin.myprofile.h2.apitoken'),
      icon: 'code',
      url: '/onboard/profile',
      tabname: 'apitoken',
      svgIcon: 'Code',
      onlyInModal: true
    });
  }

  if (
    isMSP &&
    !(flags?.marketplace && appContext?.user?.idpSubjectIdentifier)
  ) {
    settingsMenuList.mspSettingsList.data.push({
      url: '/onboard/aifeatures',
      label: 'Monica AI',
      name: 'aiFeature',
      permission: 'allow',
      svgIcon: 'MonicaAIBg',
      featureGateName: 'AI_FEATURES',
      svgIgnoreOverride: true
    });
  }

  if (isMSP) {
    settingsMenuList['contractAndBillingList'].data.push(
      {
        url: '/onboard/invoicesettings',
        label: getTranslatedText(
          intl,
          useCheckFeatureGating('QUOTING')?.enabled
            ? 'admin.stepnavi.quoteAndInvoice.settings'
            : 'admin.stepnavi.invoice.settings'
        ),
        name: 'invoiceSettings',
        icon: 'invoice-logo',
        svgIcon: 'InvoiceLogo',
        featureGateName: 'INVOICING'
      },
      {
        url: '/onboard/invoiceSchedule',
        label: getTranslatedText(
          intl,
          'client.invoice.settings.configurations.invoice.schedule',
          {
            defaultMessage: 'Invoice schedule'
          }
        ),
        name: 'invoiceSchedule',
        id: 'invoiceSchedule',
        svgIcon: 'DatePicker'
      },
      {
        url: '/onboard/invoiceTemplates',
        label: getTranslatedText(
          intl,
          'admin.invoiceSettings.invoiceTemplates.header'
        ),
        name: 'invoiceTemplate',
        id: 'invoiceTemplate',
        svgIcon: 'InvoiceIdentifier',
        permissionToCheck: 'invoiceSettings.view'
      }
    );
  }

  if (flags?.globalPatch && isWindowsManagement?.enabled) {
    settingsMenuList.assetSettingsList.data.splice(2, 0, {
      url: '/onboard/globalpatch',
      label: getTranslatedText(
        intl,
        'admin.policyManagement.globalpatch.header'
      ),
      name: 'policySet',
      svgIcon: 'PolicyLight'
    });
  }

  if (
    showNetworkView?.enabled ||
    showNetworkView?.upsell ||
    flags.networkEndpointAsset
  ) {
    settingsMenuList['assetSettingsList'].data.push({
      name: 'assetCustomFields',
      label: getTranslatedText(intl, 'snmp.credential.definition'),
      url: '/onboard/credential',
      svgIcon: 'Credential',
      featureGateName: !flags.networkEndpointAsset
        ? 'network-monitoring-system'
        : null
    });
  }

  if (flags?.autoAssignRequester) {
    // Add Auto Assign menu item
    settingsMenuList['assetSettingsList'].data.push({
      // name: 'autoAssignRequester',
      label: getTranslatedText(intl, 'rmm.assign.requester.assetAutomation'),
      url: '/onboard/asset-automation',
      svgIcon: 'AssetPC'
    });
  }

  if (flags.windowsPatchManagement) {
    settingsMenuList['assetSettingsList'].data.push({
      url: '/onboard/softwarebundle',
      label: getTranslatedText(intl, 'admin.stepnavi.software.bundle'),
      name: 'softwareBundle',
      icon: 'software_bundle',
      svgIcon: 'SoftwareBundle',
      featureGateName: 'WINDOWS_MANAGEMENT'
    });
  }
  // if (flags?.frontendPolicyRevamp && isWindowsManagement?.enabled) {
  //   settingsMenuList['assetSettingsList'].data.splice(2, 0, {
  //     url: '/onboard/devicecategory',
  //     label: getTranslatedText(intl, 'Device Category'),
  //     name: 'assetCustomFields',
  //     svgIcon: 'PolicyLight'
  //   });
  // }

  settingsMenuList['advancedCustomizationList'].data.splice(2, 0, {
    url: '/onboard/manageFields',
    label: getTranslatedText(intl, 'admin.stepnavi.manageFields'),
    name: 'manageFields',
    icon: 'CustomFields',
    svgIcon: 'CustomFields',
    authorisation: ['customFields', 'clientCustomFields']
  });

  if (isWindowsManagement?.enabled && agentFeatures?.uninstallProtection) {
    settingsMenuList['generalSettingsList'].data.unshift({
      url: '/onboard/agentuninstall',
      label: getTranslatedText(intl, 'admin.stepnavi.agentprotection'),
      name: 'securitySettings',
      svgIcon: 'Lock'
    });
  }

  if (shouldShowMDM) {
    settingsMenuList['assetSettingsList'].data.push({
      url: isMSPProduct
        ? '/onboard/mdm-configurations'
        : '/onboard/mdm-client-setup',
      label: getTranslatedText(intl, 'mdm.settings.configurations'),
      name: 'mdmOrganisationSettings',
      svgIcon: 'Mobile',
      featureGateName: 'MDM',
      skipFeatureGateCheck: true,
      isDataCleanupRequired: true,
      isTrialEligible: true
    });
  }

  return settingsMenuList;
};
